import List from '../../containers/Permissions/List';
import Edit from '../../containers/Permissions/Edit';
import Create from '../../containers/Permissions/Create';
import Show from '../../containers/Permissions/Show';

export default { List, Edit, Create, Show };
